export function validateNif(id: string): boolean {
  id = id.toUpperCase().trim();
  id = id.replace(/[\s-.]/g, ''); // remove dashes and spaces

  return (
      validateSpanishNif(id) ||
      validateDominicanID(id) ||
      validateColombianID(id) ||
      validateCUIT(id)
  );
}


function validateSpanishNif(cif: string): boolean {
  let isNif = false, isCif = false, isNie = false, chechXYZ = false;
  const num: string[] = [];
  cif = cif.toUpperCase();

  for (let i = 0; i < 9; i++) {
    num[i] = cif.substring(i, i + 1);
  }

  if (
      !cif.match(
          '((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)'
      )
  ) return false;

  if (cif.match('(^[0-9]{8}[A-Z]{1}$)')) {
    isNif = num[8] === 'TRWAGMYFPDXBNJZSQVHLCKE'.charAt(parseInt(cif.substring(0, 8)) % 23);
  }

  if (cif.match('^[ABCDEFGHJNPQRSUVW]{1}')) {
    isCif = validateCIF(cif);
  }

  if (cif.match('^[T]{1}')) {
    isNie = num[8] === cif.match('^[T]{1}[A-Z0-9]{8}$')?.toString();
  }

  if (cif.match('^[XYZ]{1}')) {
    let tmpstr = cif.replace('X', '0').replace('Y', '1').replace('Z', '2');
    chechXYZ = num[8] === 'TRWAGMYFPDXBNJZSQVHLCKE'.charAt(parseInt(tmpstr.substring(0, 8)) % 23);
  }

  return isNif || isCif || isNie || chechXYZ;
}

function validateCIF(cif: string) {
  cif = cif.trim().toUpperCase(); // Convert to uppercase and remove whitespace

  if (!/^[A-Z][0-9]{7}[A-Z0-9]$/.test(cif)) {
    return false; // CIF doesn't have the correct format
  }

  const letters = 'JABCDEFGHI';
  const digits = cif.substring(1, 7 + 1);
  const controlLetter = cif.substring(8, 1 + 8);

  let sum = 0;
  for (let i = 0; i < 7; i++) {
    let digit = parseInt(digits[i], 10);
    if (i % 2 === 0) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    sum += digit;
  }

  const remainder = (10 - (sum % 10)) % 10;
  if (!isNaN(parseInt(controlLetter, 10))) {
    // If the last character is a digit
    return remainder === parseInt(controlLetter, 10);
  } else {
    // If the last character is a letter
    return controlLetter === letters[remainder];
  }
}


function validateDominicanID(id: string): boolean {

  if (!/^\d{11}$/.test(id)) return false;

  const digits = id.split('').map(Number);
  let sum = 0;

  for (let i = 0; i < 10; i++) {
    let val = digits[i] * (i % 2 === 0 ? 1 : 2);
    if (val > 9) val = Math.floor(val / 10) + (val % 10);
    sum += val;
  }

  const checkDigit = (10 - (sum % 10)) % 10;

  console.log(checkDigit);


  return checkDigit === digits[10];
}

function validateColombianID(id: string): boolean {
  return /^\d{6,11}$/.test(id);
}

function validateCUIT(cuit: string): boolean {
  cuit = cuit.replace(/-/g, '');
  if (!/^\d{11}$/.test(cuit)) return false;

  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const digits = cuit.split('').map(Number);
  const sum = weights.reduce((acc, w, i) => acc + w * digits[i], 0);
  const checkDigit = 11 - (sum % 11);

  return (checkDigit === 11 ? 0 : checkDigit === 10 ? 9 : checkDigit) === digits[10];
}
